import dayjs from "dayjs";

export function hydrateMapIncident(d: MapIncident): HydratedMapIncident {
  return {
    ...d,
    dateTimeDayjs: dayjs(d.dateTime),
  };
}

export function hydrateMapIncidents(d: Array<MapIncident>): Array<HydratedMapIncident> {
  return d.map(hydrateMapIncident);
}
